import DragScroll from 'src/componentes/dragscroll';

import { BOW_TIE_SIDE } from '../constants';
import { flattenBranches } from '../utils';
import BowTieBranch from './BowTieBranch';
import BowTieLegend from './BowTieLegend';

function BowTieDiagram({ values, disabled, onControlClick }) {
  const causas = flattenBranches(values?.causas, 'causas');
  const consequencias = flattenBranches(values?.consequencias, 'consequencias');
  const nomeRisco =  values?.nome ?? '';

  return (
    <div className="bow-tie">
      <BowTieLegend />

      <DragScroll overflow="auto" height="auto" width="100%">
        <div className="bow-tie__canvas">
          <div className="bow-tie__side bow-tie__side--left">
            {causas.map((cause, index) => (
              <BowTieBranch
                key={`${BOW_TIE_SIDE.PREVENTIVO}-${cause?.id ?? index}`}
                branch={cause}
                side={BOW_TIE_SIDE.PREVENTIVO}
                index={index}
                disabled={disabled}
                onControlClick={onControlClick}
              />
            ))}
          </div>

          <div className="bow-tie__risk" title={nomeRisco}>
            {nomeRisco}
          </div>

          <div className="bow-tie__side bow-tie__side--right">
            {consequencias.map((consequence, index) => (
              <BowTieBranch
                key={`${BOW_TIE_SIDE.CORRETIVO}-${consequence?.id ?? index}`}
                branch={consequence}
                side={BOW_TIE_SIDE.CORRETIVO}
                index={index}
                disabled={disabled}
                onControlClick={onControlClick}
              />
            ))}
          </div>
        </div>
      </DragScroll>
    </div>
  );
}

export default BowTieDiagram;
